"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  normalizeDoubleByteToStandard: true
};
exports.default = void 0;
exports.normalizeDoubleByteToStandard = normalizeDoubleByteToStandard;
var _normalizeDoubleByteToStandard = require("./normalizeDoubleByteToStandard.types");
Object.keys(_normalizeDoubleByteToStandard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _normalizeDoubleByteToStandard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _normalizeDoubleByteToStandard[key];
    }
  });
});
/** normalizeDoubleByteToStandard is used to normalize a string containing
 * double-byte(Japanese, Chinese, Korean, etc) words to a standardized form
 * using the Normalization Form Canonical Composition (NFC).
 */
function normalizeDoubleByteToStandard(inputStr, unicodeNormalizationForm) {
  return inputStr.normalize(_normalizeDoubleByteToStandard.UNICODE_NORMALIZATION_FORMS.includes(unicodeNormalizationForm) ? unicodeNormalizationForm : 'NFC');
}
var _default = exports.default = normalizeDoubleByteToStandard;